export default __webpack_public_path__ + "static/ph_liner_install_done-fef8712e6d09bdcddc5fcb7883b3fac1.jpeg";